module.exports = __webpack_public_path__ + "static/MT_Benefit-01.d8249f10.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/benefit-icons/MT_Benefit-01.png
// module id = 1461
// module chunks = 169858455373905